<template>
  <b-badge variant="danger" :class="classes">{{
    $t(`entity.deleted`)
  }}</b-badge>
</template>

<script>
export default {
  name: "DeletedBadge",
  props: {
    deletedAt: String
  },
  computed: {
    classes() {
      if (!this.deletedAt) {
        return "d-none";
      } else {
        return "";
      }
    }
  }
};
</script>

<style>
</style>